/* global $ */
import * as types from './action-types';

export function getStreamUrl(){
  return (dispatch, getState) => {
    const streamUrl = getState().app.player.toJS().stream_url;
    dispatch({
      type: types.UPDATE_CURRENT_STREAM_URL,
      data: streamUrl
    });
  }
}

let currentSong = null
export function checkIcecastMetadata(){
  return (dispatch, getState) => {
    const streamUrl = getState().app.player.toJS().stream_url;
    // check the lambda now playing
    let lambdaUrl = 'https://lambda.customchannels.rocks/nowplaying?url=' + streamUrl;

    $.ajax({
      method: "GET",
      url: lambdaUrl,
      beforeSend: function(xhr, status){
      },
      error: function(xhr, status, error){
        return console.error(xhr, status, error);
      },
      success: function(data, status, xhr){
        if(data.track !== currentSong){
          dispatch(updateTrackMetadata(data.track));
          currentSong = data.track;
        }
      }
    });
  };
}

export function updateTrackMetadata(artistTrack){
  artistTrack = artistTrack.split(' - ');
  let artist = artistTrack[0];
  return (dispatch, getState) => {
    const nowplayingUrl = getState().app.player.toJS().nowplaying_url;
    $.ajax({
      method: "GET",
      url: nowplayingUrl,
      error: function(xhr, status, error){
        return console.error(xhr, status, error);
      },
      success: function(data, status, xhr){
        // go through the remix tracks and check to see if the artist
        // matches one of the tracks in the history
        for (var i = 0; i < data.data.length; i++) {
          if(data.data[i].artist === artist){
            dispatch({
              type: types.UPDATE_CURRENT_TRACK,
              data: data.data[i]
            });
          }
        };

        let tracks = data.data;
        tracks.splice(0, 1);

        dispatch(updateHistory(tracks));
      }
    });

  };
}

export function updateHistory(data){
  return {
    type: types.UPDATE_HISTORY,
    data: data
  };
}



// WEBPACK FOOTER //
// ./src/actions/sam-actions.js